<template>
  <div class="modal fade" id="measurableOutcomeIdeasModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Measurable Outcome Ideas</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h6>Summative Assessment</h6>
          <h6>Formative Assessment</h6>
          <h6>Survey</h6>
          <h6>Mentality Shift</h6>
          <h6>Participation</h6>
          <h6>Student Engagement</h6>
          <h6>Project Completion</h6>
          <h6>New Content/Curriculum</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MeasurableOutcomeIdeasModal",
  data() {
    return {};
  },
  methods: {}
};
</script>
